enum ShiftDigitalEventName {
  BrochureDownload = 'brochureDownload',
  CarouselClick = 'carouselClick',
  ClickToCall = 'clickToCall',
  FilterSearch = 'filterSearch',
  FormInitiation = 'formInitiation',
  FormShown = 'formShown',
  FormSubmission = 'formSubmission',
  GetDirections = 'getDirections',
  OfferClick = 'offerClick',
  ScheduleServiceClick = 'scheduleServiceClick',
  ServiceOfferClick = 'serviceOfferClick',
  TypedSearch = 'typedSearch',
  VehicleQuickView = 'vehicleQuickView'
}

export default ShiftDigitalEventName;
